import { render, staticRenderFns } from "./SMSPopup.vue?vue&type=template&id=631f7ecf&scoped=true&"
import script from "./SMSPopup.vue?vue&type=script&lang=js&"
export * from "./SMSPopup.vue?vue&type=script&lang=js&"
import style0 from "./SMSPopup.vue?vue&type=style&index=0&id=631f7ecf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631f7ecf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
